import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMatch, useNavigate } from 'react-router-dom';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Button from 'layout/atoms/Button/Button';
import ConfirmationModal from 'layout/molecules/ConfirmationModal';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { removeFolder, selectStatus } from 'store/specificationsFoldersSlice';
// Rendered once, top-level, by ModalsManager — not per FolderCard. Mounting it
// inline in each FolderCard meant the modal (and its close-transition effect)
// unmounted together with the deleted folder before it could ever clear itself
// out of layoutSlice's showModals, permanently blocking the next delete.
function RemoveFolderModal() {
    var _a, _b;
    const { t } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const status = useSelector(selectStatus);
    const modalData = (_a = useSelector(selectModalByName('removeFolder'))) === null || _a === void 0 ? void 0 : _a.data;
    const navigate = useNavigate();
    const openFolderId = (_b = useMatch('/specifications/folders/:folderId')) === null || _b === void 0 ? void 0 : _b.params.folderId;
    const folderId = modalData === null || modalData === void 0 ? void 0 : modalData.id;
    const folderName = modalData === null || modalData === void 0 ? void 0 : modalData.name;
    const parentFolderId = modalData === null || modalData === void 0 ? void 0 : modalData.parentId;
    const handleDelete = () => {
        dispatch(removeFolder({ folderId, parentFolderId }))
            .unwrap()
            .then(() => {
            dispatch(closeModal({ name: 'removeFolder' }));
            // Deleting the open folder (e.g. from the folders tree) would leave the user on a dead page.
            if (openFolderId === folderId && parentFolderId) {
                navigate(`/specifications/folders/${parentFolderId}`);
            }
        });
    };
    return (React.createElement(ConfirmationModal, { name: "removeFolder", header: React.createElement(React.Fragment, null,
            React.createElement(TrashSvg, null),
            t('REMOVE_FOLDER')), buttons: React.createElement(Button, { color: "danger", onClick: handleDelete }, t('common:delete')), action: handleDelete, loading: status.remove === 'loading' },
        React.createElement("h2", null, t('REMOVE_FOLDER_HEADER', { name: folderName })),
        React.createElement("p", null, t('REMOVE_FOLDER_MESSAGE'))));
}
export default memo(RemoveFolderModal);
